<template>
  <div :class="['back', { 'back--vertical': vertical }]">
    <div class="back__inner">
      <div class="back__aside">
        <div
          class="back__link"
          @click="navigate"
        >
          <arrow-icon
            v-if="showIcon"
            class="back__icon"
          />
          {{ redirect.text }}
        </div>
      </div>
      <div class="back__body">
        <h3
          class="back__title title title--primary"
          v-text="title"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

import arrowIcon from './icons/arrowIcon.vue';

export default defineComponent({
  name: 'Back',

  components: {
    arrowIcon
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    redirect: {
      type: Object,
      default: () => {
        return {
          name: 'main',
          text: 'Главная'
        };
      }
    },
    vertical:{
      type: Boolean,
      default: false,
    }
  },

  setup (props) { 
    const router = useRouter();
    
    const navigate = () => router.push(props.redirect);

    return {
      navigate
    };
  }
});
</script>
<style lang="scss" scoped>
.back{
    &__body{
      width: 100%;
      position: relative;
    }
    &__link{
      display: flex;
      align-items: center;
      text-decoration: none;
      cursor: pointer;
    }
    &__aside{
      position: absolute;
      z-index: 1;
    }
    &__icon{
      margin-right: 16px;
    }
    &__title{
      text-align: center;
      width: 60%;
      margin: 0 auto;
    }
}
.back--vertical{
.back{
  &__inner{
    display: flex;
    flex-direction: column;
    position: static;
  }
  &__aside{
    margin-bottom: 24px;
    position: static;
  }
  &__title{
    text-align: left;
    width: 100%;
  }
}
  
}
.tele2{
  .back{
    &__title{
      color: $tele2-primary-black;
    }
    &__link{
      color: $tele2-primary-gray;
      font-family: 'OpenSans', sans-serif;    
    }
  }
}
.altel{
  .back{
    &__title{
      color: $altel-primary-black;
    }
    &__link{
      color: black;
    }
  }
  
}
@media (min-width: 320px) and (max-width: 480px) {
.back{
  &__inner{
    display: flex;
    flex-direction: column;
    position: static;
  }
  &__aside{
    margin-bottom: 24px;
    position: static;

  }
  &__title{
    text-align: left;
    width: 100%;
  }
}

}
</style>